import { render, staticRenderFns } from "./ActivityEndPage.vue?vue&type=template&id=3cbece2e"
import script from "./ActivityEndPage.vue?vue&type=script&lang=js"
export * from "./ActivityEndPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports